import { Record, List, Map } from 'immutable';

import { LOBBY_TYPES } from '../../constants/casino';

import {
  REQUEST_LOBBIES,
  SET_LOBBIES,
  SET_LOBBIES_BY_PRODUCT,
  SET_GAME_REAL_MODE,
  SET_AVAILABILITY,
  GET_GAME_REAL_MODE,
  SET_GAME_REAL_MODE_ERROR,
  SET_CASINO_BANNERS,
  SET_CASINO_VISIBILITY_RESTRICTED,
  GET_LOBBY_VIEWS,
  RESET_GAME_REAL_MODE_URL,
} from './actions';

const LobbyContainer = new Record({
  id: '',
  data: new List(),
  loading: false,
  error: '',
});

export const Lobby = new Record({
  id: '',
  name: '',
  lobbySlug: '',
  loading: false,
  sections: new List(),
});

export const Section = new Record({
  id: '',
  name: '',
  layoutType: '',
  loading: false,
  lettersWithGames: [],
  games: new List(),
});

export const Game = new Record({
  id: '',
  funModeAvailable: '',
  imageUrl: '',
  launchUrl: '',
  description: '',
  provider: '',
  title: '',
  jackpot: null
});

export const CasinoBanner = new Record({
  excludedUsers: '',
  image: '',
  mobileImage: '',
  position: 0,
  redirectUrl: '',
  lobbyId: '',
  lobbyViewId: ''
});

const InitialState = new Record({
  lobbies: new Map({
    'classic-casino': new LobbyContainer(),
    'live-casino': new LobbyContainer(),
    virtuals: new LobbyContainer()
  }),
  gameRealModeLaunchUrl: '',
  loadingRealModeLaunchUrl: false,
  gameRealModeLaunchUrlError: '',
  available: true,
  casinoBanners: new Map(),
  visibilityRestricted: false,
});

export const initialState = new InitialState();

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_LOBBY_VIEWS: {
      const { lobbyId } = payload;

      if (!lobbyId) {
        return state
          .setIn(['lobbies', 'classic-casino', 'loading'], true)
          .setIn(['lobbies', 'live-casino', 'loading'], true);
      }

      const currentClassicLobbies = state.getIn(['lobbies', 'classic-casino', 'data']);
      const currentLiveLobbies = state.getIn(['lobbies', 'live-casino', 'data']);

      const classicLobbiesUpdate = currentClassicLobbies.map(lobby => (
        lobby.set('loading', lobby.id === 'classic-casino')
      ));

      const liveLobbiesUpdate = currentLiveLobbies.map(lobby => (
        lobby.set('loading', lobby.id === 'live-casino')
      ));

      return state
        .setIn(['lobbies', 'classic-casino', 'data'], classicLobbiesUpdate)
        .setIn(['lobbies', 'live-casino', 'data'], liveLobbiesUpdate);
    }
    case REQUEST_LOBBIES: {
      const lobbyType = LOBBY_TYPES[payload];

      const currentLobbies = state.getIn(['lobbies', lobbyType, 'data']);

      const lobbiesUpdate = currentLobbies.map(lobby => (
        lobby.set('loading', true)
      ));

      return state.setIn(['lobbies', lobbyType, 'data'], lobbiesUpdate);
    }
    case SET_AVAILABILITY: {
      return state.set('available', payload);
    }
    case SET_LOBBIES: {
      const { lobbyViews } = payload;
      const lobbiesUpdate = new Map(
        Object.keys(lobbyViews).reduce((acc, k) => ({
          ...acc,
          [lobbyViews[k].id]: new LobbyContainer({
            id: lobbyViews[k].id,
            data: new List(lobbyViews[k].lobbies.map((lobby) => (
              new Lobby({
                ...lobby,
                loading: false,
                sections: lobby.sections ? new List(lobby.sections.map((section) => {
                  const gms = section.games ? section.games : new List();
                  return (
                    new Section({
                      ...section,
                      games: section.id !== 'a-z' ?
                        gms.map((game) => (new Game(game)))
                        : Object.keys(gms).map((key) => [key, section.games[key]])
                    })
                  );
                })) : new List(),
              })
            ))),
          })
        })
          , {})
      );
      return state.setIn(['lobbies'], lobbiesUpdate);
    }
    case SET_LOBBIES_BY_PRODUCT: {
      const { lobbies, product: productStoreKey } = payload;

      const lobbiesUpdate = state.getIn(['lobbies', productStoreKey]).merge({
        id: productStoreKey,
        data: new List(lobbies.map((lobby) => (
          new Lobby({
            ...lobby,
            loading: false,
            sections: lobby.sections ? new List(lobby.sections.map((section) => (
              new Section({
                ...section,
                games: section.id !== 'a-z' ? section.games.map((game) => (
                  new Game(game)
                )) : Object.keys(section.games).map((key) => [key, section.games[key]]),
              })
            ))) : new List(),
          })
        ))),
        loading: false,
        error: ''
      });

      return state.setIn(['lobbies', productStoreKey], lobbiesUpdate);
    }
    case GET_GAME_REAL_MODE: {
      return state
        .set('gameRealModeLaunchUrl', '')
        .set('loadingRealModeLaunchUrl', true);
    }
    case SET_GAME_REAL_MODE: {
      return state
        .set('gameRealModeLaunchUrl', payload.gameRealModeUrl)
        .set('loadingRealModeLaunchUrl', false)
        .set('gameRealModeLaunchUrlError', '');
    }
    case SET_GAME_REAL_MODE_ERROR: {
      return state
        .set('gameRealModeLaunchUrl', '')
        .set('loadingRealModeLaunchUrl', false)
        .set('gameRealModeLaunchUrlError', payload);
    }
    case RESET_GAME_REAL_MODE_URL: {
      return state
        .set('gameRealModeLaunchUrl', '')
        .set('loadingRealModeLaunchUrl', false)
        .set('gameRealModeLaunchUrlError', '');
    }
    case SET_CASINO_BANNERS: {
      return state.set('casinoBanners', new Map(payload.map((banner) => [[banner.lobbyId], new CasinoBanner(banner)])));
    }
    case SET_CASINO_VISIBILITY_RESTRICTED: {
      return state.set('visibilityRestricted', payload);
    }
    default: {
      return state;
    }
  }
};

